angular.module("UIStateManager", []);
